'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { JContainer } from '@/app/components/ui/layout';
import { getStaticAssetUrl } from '@/app/lib/utils/static-asset-url';

export default function ArticleNotFound({
    returnLink,
    type,
}: {
    returnLink: string;
    type: 'weekly' | 'news' | 'research' | 'others';
}) {
    const { t } = useTranslation('article-not-found');

    return (
        <JContainer
            size="full"
            className="flex h-screen min-h-[50vh] flex-col items-center bg-white py-20 text-center"
        >
            <Image
                src={getStaticAssetUrl('/blog/img-404.webp')}
                alt="404 Not Found"
                width={120}
                height={120}
                className="desktop:mt-[100px] mb-[32px] mt-[80px]"
            />
            <p className="j-h5 mb-[8px]">{t('title')}</p>
            <p className="j-t2 text-[#6A696C]">{t('description')}</p>
            <Link
                href={returnLink}
                className="j-t2 mt-[32px] w-[87.5vw] max-w-[320px] rounded-[65px] bg-black px-[24px] py-[10px] text-white"
            >
                {t(`return`)}
            </Link>
        </JContainer>
    );
}
